import { Collection, LongString, MaxString, ModelBase, NormalString, ObservableCollection, Property, Required, VeryLongString } from '@skylab-shared/core';
import { CalculationMethod } from '../common/calculation-method';
import { RelatedEntity } from '../common/related-entity';
import { DocumentBuyerModel } from '../document/document-buyer.model';
import { DocumentClientModel } from '../document/document-client.model';
import { ExchangeRateModel } from '../exchange-rate/exchange-rate.model';
import { VatTableItemModel } from '../vat-table/vat-table-item.model';
import { InventoryCostCalculationMethod } from './inventory-cost-calculation-method';
import { InventoryDocumentItemModel } from './inventory-document-item.model';
import { InventoryDocumentKind } from './inventory-document-kind';
import { InventoryRelationshipCreationMethod } from './inventory-relationship-creation-method';

export class InventoryGoodsReceiptDocumentModel extends ModelBase {
    @Property({ identifiable: true })
    public id: number;

    @Property()
    @VeryLongString('data-model.inventory-document-model.validation.document-number.length')
    public documentNumber: string;

    @Property()
    public numberingId: number;

    @Property()
    public kind: InventoryDocumentKind;

    @Property(DocumentClientModel, { nullable: true })
    public seller: DocumentClientModel | null;

    @Property(DocumentBuyerModel, { nullable: true })
    public supplier: DocumentBuyerModel | null;

    @Property(String, { nullable: true })
    @MaxString('data-model.document.validation.note.length')
    public note: string | null;

    @Property()
    @Required()
    public calculationMethod: CalculationMethod.Gross | CalculationMethod.Net;

    @Property()
    @Required()
    public costCalculationMethod: InventoryCostCalculationMethod;

    @Property()
    @Required()
    public currencyId: number;

    @Property(ExchangeRateModel, { nullable: true })
    public exchangeRate: ExchangeRateModel | null;

    @Property(Date, {nullable: true})
    public issueDate: Date | null;

    @Property()
    public receiptDate: Date;

    @Property()
    public grossValue: number;

    @Property()
    public netValue: number;

    @Property()
    public issuedByVatPayer: boolean;

    @Property(String, {nullable: true})
    @LongString('data-model.document.validation.transaction-location.length')
    public transactionLocation: string | null;

    @Property()
    @Required('data-model.inventory-document-model.validation.inventory.required')
    public inventoryId: number;

    @Property(String, {nullable: true})
    public recipient: string | null;

    @Property(String, {nullable: true})
    @NormalString('data-model.inventory-document-model.validation.issuer.length')
    public issuer: string | null;

    @Collection({ type: InventoryDocumentItemModel })
    public items: ObservableCollection<InventoryDocumentItemModel>;

    @Collection({ type: VatTableItemModel })
    public vatTableItems: ObservableCollection<VatTableItemModel>;

    @Collection({ type: VatTableItemModel })
    public vatTableItemsInBaseCurrency: ObservableCollection<VatTableItemModel>;

    @Property()
    public relatedCommercialDocuments: RelatedEntity[];

    @Property()
    public creationMethod: InventoryRelationshipCreationMethod;
}
